







































































































































































































































































































import axios from 'axios';
import { get, uniqBy, uniqueId, filter, orderBy } from 'lodash';
import { Event, User } from '../../../types/GlobalTypes';
import CoEventTicketCheckout from '@/components/Organisms/co-event-ticket-checkout/CoEventTicketCheckout.vue';
import CoImage from '../../Atoms/co-image/CoImage.vue';
import CoText from '../../Atoms/co-text/CoText.vue';
import CoButton from '../../Atoms/co-button/CoButton.vue';
import CoHeadline from '../../Atoms/co-headline/CoHeadline.vue';
import CoSkeleton from '../../Atoms/co-skeleton/CoSkeleton.vue';
import CoThumbnail from '../../Molecules/co-thumbnail/CoThumbnail.vue';
import CoDate from '../co-date/CoDate.vue';
import CoPill from '../../Atoms/co-pill/CoPill.vue';
import CoConfirmation from '../co-confirmation/CoConfirmation.vue';
import CoPeople from '../co-people/CoPeople.vue';
import CoEventTicketCheckoutAsGuest from '@/components/Organisms/co-event-ticket-checkout-as-guest/CoEventTicketCheckoutAsGuest.vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoPrice from '@/components/Atoms/co-price/coPrice.vue';

export default {
    components: {
        CoSkeleton,
        CoHeadline,
        CoButton,
        CoText,
        CoImage,
        CoThumbnail,
        CoDate,
        CoPill,
        CoConfirmation,
        CoEventTicketCheckout,
        CoPeople,
        CoEventTicketCheckoutAsGuest,
        CoIcon,
        CoPrice,
    },
    name: 'CoEvent',
    props: {
        event: {
            type: Object as () => Event,
            required: true,
            default: () => ({}),
        },
        variant: {
            type: String,
            validator: (value: string) => ['default', 'micro', 'list', 'full'].includes(value),
            default: 'default',
            required: false,
        },
        loading: {
            type: Boolean,
            default: false,
            required: false,
        },
        me: {
            type: Object,
            required: false,
        },
        link: {
            type: Boolean,
            required: false,
            default: true,
        },
        disableQuickActions: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            meLocal: get(this, 'me', null) || {
                ...get(this.$store, 'state.me', {}),
                ...get(this.$store, 'state.me.Profile', {}),
            },
            amIattending: false,
            amIorganising: false,
            currency: get(this.$store, 'state.space.Currency', null),
        };
    },
    computed: {
        isEventPast() {
            return this.event.EndDate < new Date().getTime() / 1000;
        },
        participantList() {
            const organizers = this.event?.Organizers || [];
            const participants = this.event?.Participants || [];
            const allUsers = [...organizers, ...participants];
            // filter out duplicates
            const uniqueUsers = uniqBy(allUsers, 'ID');
            return uniqueUsers;
        },
        amILoggedIn() {
            return this.meLocal.ID;
        },
        priceRange() {
            if (!this.event?.Tickets || this.event.Tickets.length === 0) return null;
            // filter out tickets that are deleted
            const tickets = filter(this.event.Tickets, (e) => !e.Deleted);
            //
            const prices = orderBy(
                tickets.map((ticket) => ({
                    PriceInCents: 0, // make sure free tickets are also shown
                    ...ticket, // if PriceInCents is set, it will override the 0 above
                })),
                ['PriceInCents'],
                ['asc']
            ).map((ticket) => ({
                ...ticket,
                Currency: this.currency || '',
            }));
            return prices;
        },
        taxRates() {
            if (!this.event?.Tickets || this.event.Tickets.length === 0) return [];
            // filter out tickets that are deleted
            const tickets = filter(this.event.Tickets, (e) => !e.Deleted);
            return uniqBy(
                tickets.map((ticket) => ticket.TaxRate).filter((taxRate) => taxRate),
                'ID'
            );
        },
    },
    mounted() {
        // set amIattending and amIorganising
        this.amIattending = this.event?.Participants?.some((user) => user?.ID && user?.ID === this.meLocal?.ID);
        this.amIorganising = this.event?.Organizers?.some((user) => user?.ID && user?.ID === this.meLocal?.ID);
    },
    watch: {
        event: {
            handler(newValue, oldValue) {
                // reevaluate amIattending and amIorganising
                this.amIattending = this.event?.Participants?.some((user) => user?.ID && user?.ID === this.meLocal?.ID);
                this.amIorganising = this.event?.Organizers?.some((user) => user?.ID && user?.ID === this.meLocal?.ID);
            },
            deep: true,
        },
    },
    methods: {
        get,
        uniqueId,
        attendEvent(event) {
            if (!this.meLocal) return;

            this.$emit('attend', event);
            this.event.Participants
                ? this.event.Participants.unshift(this.meLocal)
                : (this.event.Participants = [this.meLocal]);

            axios({
                method: 'POST',
                url: '/event/participant',
                data: {
                    EventID: this.event.ID,
                    ParticipantID: this.meLocal.ID,
                },
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {})
                .catch((error) => {
                    this.$emit('error', { message: 'Failed to attend event', error });
                    this.event.Participants.shift();
                });
        },
        // unattendEvent(event) {
        //     if (!this.meLocal) return;
        //     this.event.Participants
        //         ? (this.event.Participants = this.event.Participants.filter((user: User) => {
        //               return user.ID !== this.meLocal.ID;
        //           }))
        //         : (this.event.Participants = null);
        //     this.$emit('unattend', event);
        // },
    },
};
